


























































































































import { Component, PropSync, Vue } from "vue-property-decorator";
import { OfficialRateModel } from "@/components/property/official-rates/types";

@Component
export default class OfficialRatesArrivalsDepartures extends Vue {
  @PropSync("officialRate") officialRateInternal?: OfficialRateModel;

  get someArrivals() {
    if (!this.officialRateInternal) return false;
    return (
      this.officialRateInternal.noArrivalsMonday ||
      this.officialRateInternal.noArrivalsTuesday ||
      this.officialRateInternal.noArrivalsWednesday ||
      this.officialRateInternal.noArrivalsThursday ||
      this.officialRateInternal.noArrivalsFriday ||
      this.officialRateInternal.noArrivalsSaturday ||
      this.officialRateInternal.noArrivalsSunday
    );
  }

  get allArrivals() {
    if (!this.officialRateInternal) return false;
    return (
      this.officialRateInternal.noArrivalsMonday &&
      this.officialRateInternal.noArrivalsTuesday &&
      this.officialRateInternal.noArrivalsWednesday &&
      this.officialRateInternal.noArrivalsThursday &&
      this.officialRateInternal.noArrivalsFriday &&
      this.officialRateInternal.noArrivalsSaturday &&
      this.officialRateInternal.noArrivalsSunday
    );
  }

  get someDepartures() {
    if (!this.officialRateInternal) return false;
    return (
      this.officialRateInternal.noDeparturesMonday ||
      this.officialRateInternal.noDeparturesTuesday ||
      this.officialRateInternal.noDeparturesWednesday ||
      this.officialRateInternal.noDeparturesThursday ||
      this.officialRateInternal.noDeparturesFriday ||
      this.officialRateInternal.noDeparturesSaturday ||
      this.officialRateInternal.noDeparturesSunday
    );
  }

  get allDepartures() {
    if (!this.officialRateInternal) return false;
    return (
      this.officialRateInternal.noDeparturesMonday &&
      this.officialRateInternal.noDeparturesTuesday &&
      this.officialRateInternal.noDeparturesWednesday &&
      this.officialRateInternal.noDeparturesThursday &&
      this.officialRateInternal.noDeparturesFriday &&
      this.officialRateInternal.noDeparturesSaturday &&
      this.officialRateInternal.noDeparturesSunday
    );
  }

  toggleArrivals() {
    if (!this.officialRateInternal) return;
    if (!this.allArrivals) {
      this.officialRateInternal.noArrivalsMonday = true;
      this.officialRateInternal.noArrivalsTuesday = true;
      this.officialRateInternal.noArrivalsWednesday = true;
      this.officialRateInternal.noArrivalsThursday = true;
      this.officialRateInternal.noArrivalsFriday = true;
      this.officialRateInternal.noArrivalsSaturday = true;
      this.officialRateInternal.noArrivalsSunday = true;
    } else {
      this.officialRateInternal.noArrivalsMonday = false;
      this.officialRateInternal.noArrivalsTuesday = false;
      this.officialRateInternal.noArrivalsWednesday = false;
      this.officialRateInternal.noArrivalsThursday = false;
      this.officialRateInternal.noArrivalsFriday = false;
      this.officialRateInternal.noArrivalsSaturday = false;
      this.officialRateInternal.noArrivalsSunday = false;
    }
  }

  toggleDepartures() {
    if (!this.officialRateInternal) return;
    if (!this.allDepartures) {
      this.officialRateInternal.noDeparturesMonday = true;
      this.officialRateInternal.noDeparturesTuesday = true;
      this.officialRateInternal.noDeparturesWednesday = true;
      this.officialRateInternal.noDeparturesThursday = true;
      this.officialRateInternal.noDeparturesFriday = true;
      this.officialRateInternal.noDeparturesSaturday = true;
      this.officialRateInternal.noDeparturesSunday = true;
    } else {
      this.officialRateInternal.noDeparturesMonday = false;
      this.officialRateInternal.noDeparturesTuesday = false;
      this.officialRateInternal.noDeparturesWednesday = false;
      this.officialRateInternal.noDeparturesThursday = false;
      this.officialRateInternal.noDeparturesFriday = false;
      this.officialRateInternal.noDeparturesSaturday = false;
      this.officialRateInternal.noDeparturesSunday = false;
    }
  }
}
